import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OutboxSingleRequestCreationComponent } from './outbox-single-request-creation/outbox-single-request-creation.component';
import { NgClass, NgIf } from '@angular/common';
import { OutboxMultiRequestCreationComponent } from './outbox-multi-request-creation/outbox-multi-request-creation.component';

@Component({
    selector: 'app-outbox-request-creation',
    templateUrl: './outbox-request-creation.component.html',
    styleUrl: './outbox-request-creation.component.scss',
    imports: [NgClass, NgIf, OutboxSingleRequestCreationComponent, OutboxMultiRequestCreationComponent]
})
export class OutboxRequestCreationComponent {
  @Input() newReqestPanelVisible!: boolean
  @Output() close = new EventEmitter<void>();
  @ViewChild(OutboxSingleRequestCreationComponent) outboxSingleRequestCreationComponent!: OutboxSingleRequestCreationComponent;
  activeTab: string | null = 'single_request';
  tabList: any = ['single_request', 'multiple_request']
  fileName: string = '';
  isDropdownOpen: boolean = false;
  placeholder: string = 'Select an option';
  selectedOption: string | null = null;
  showPreview: boolean = false;

  // ex. list of touchpoints
  options: string[] = ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5'];

  constructor(private router: Router, private route: ActivatedRoute) { }

  onCheckboxChange(item: any, event: Event) {
    item.checked = (event.target as HTMLInputElement).checked;
  }

  ngOnInit() {
    // Initialize activeTab based on query parameters
    this.route.queryParams.subscribe((params: any) => {
      let tabName = (this.tabList.indexOf(params['active_tab']) >= 0) ? params['active_tab'] : 'single_request'
      this.toggleTab(tabName)
    })
  }
  ngOnChanges(changes: SimpleChanges): void {
  }

  toggleTab(tab: string): void {
    this.activeTab = tab;
  }

  closeNewRequestPanel() {
    this.outboxSingleRequestCreationComponent?.resetForm();
    this.activeTab = 'single_request';
    this.close.emit();
  }


  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectOption(option: string) {
    this.selectedOption = option;
    this.isDropdownOpen = false; 
  }

  // todo
  onFileSelect(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.fileName = input.files[0].name;
      this.showPreview = true; 
    } else {
      this.fileName = '';
      this.showPreview = false;
    }
  }
  deleteFile(): void {
    this.fileName = ''; 
    this.showPreview = false;
    (document.getElementById('file-upload') as HTMLInputElement).value = ''; // Clear the file input
  }
}

